/*
 * @Author: your name
 * @Date: 2020-06-23 10:54:38
 * @LastEditTime: 2020-06-23 11:11:14
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \leXiangH5线下落地页\src\utils\login.js
 */
import Router from '../router/index.js';
import { Toast } from "vant";
import { domain } from '@/config.js'
import api from '@/services/api.js'
import qs from 'qs'
import { inWeixin } from 'web-launch-app'

/**
 * 检测用户是否登录
 */
export const checkUserStatus = (route) => {
    const token = localStorage.getItem("token");
    const code = route.query.invite_code || route.query.invitecode || null;
    if (inWeixin && !token) {
        // 没有token，则登录，缓存code
        login(route);
        if (code) {
            localStorage.setItem("inviteCode", code);
        }
    } else if (code !== null && token) {
        // 如果已经登录且有code，则绑定
        bindMembersInfo(code);
    }
}

/**
 * 登录
 * @param {string} route // 当前页面的路由，登录后返回
 * @param {string} code // 是否有登录码code
 */
export const login = async (route, code) => {
    // 缓存登录时检测的路由
    if (route && !JSON.parse(localStorage.getItem("LoginAfterPath"))) {
        let router = {
            path: route.path,
            query: route.query
        }
        localStorage.setItem("LoginAfterPath", JSON.stringify(router))
    }

    const { href } = window.location;
    const queryStr = href.split("?")[1];

    const query = qs.parse(queryStr);
    if (query.invite_code) {
        localStorage.setItem('inviteCode', query.invite_code);
    }

    try {
        let params = { mode: "web", domain };
        // 如果有code
        if (code) {
            params = { ...params, code }
        }
        const res = await api.get('/api/v1/users/login', {
            params
        })

        if (!code) {
            // 第三方登录，跳转到 code 重定向页
            window.location.href = res.data.data;
        } else {
            // 用户登录，登录成功
            const { data } = res.data;
            localStorage.setItem("token", data.token);

            // 检测是否有邀请码
            const inviteCode = localStorage.getItem("inviteCode");
            if (inviteCode) {
                bindMembersInfo(inviteCode);
            }


            let router = JSON.parse(localStorage.getItem("LoginAfterPath")) || '/';

            if (route && route.path) {
                router = {
                    path: route.path,
                    query: route.query
                }
            } else {
                route = "/"
            }

            // 跳转到该路由
            console.log(router,'router')
            Router.push(router);
        }

    } catch (error) {
        console.log(error);
    }
}

/**
 * 绑定用户关系
 * @param {string} inviteCode 
 */
export const bindMembersInfo = async (inviteCode) => {
    try {
        const res = await api.post("/api/v1/members/bind", {
            invitecode: inviteCode
        });
        Toast({
            message: res.data.data,
            duration: 1000,
            forbidClick: true
        });
    } catch (error) {
        console.log(error);
    }
}

// 返回下载页
// function backToDownLoad() {
//     Vue.prototype.$router.push("/downloadapp");
// }